/* CDS Anim — animation de revelation partagee (IntersectionObserver) */
(function () {
  'use strict';

  if (window.CDSAnim) { return; }

  /* Declenchement des que l'element a penetre de 10% du viewport (rootMargin
     negatif + threshold 0). Un threshold proportionnel a la hauteur (ex 0.15)
     devient inatteignable sur les elements plus hauts que ~6 viewports
     (article complet, FAQ, grille favoris) : le contenu resterait invisible. */
  var IO_OPTIONS = { threshold: 0, rootMargin: '0px 0px -10% 0px' };

  function prefersReducedMotion() {
    try {
      return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
    } catch (e) {
      return false;
    }
  }

  function revealNow(el) {
    var cls = el.getAttribute('data-cds-anim');
    if (!cls) { return; }
    el.classList.add(cls);
    el.dataset.cdsAnimDone = '1';
  }

  function observe(el) {
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        var entry = entries[i];
        if (entry.isIntersecting) {
          if (!entry.target.dataset.cdsAnimDone) {
            revealNow(entry.target);
          }
          io.unobserve(entry.target);
        }
      }
    }, IO_OPTIONS);
    io.observe(el);
  }

  function scan(root) {
    var scope = root || document;
    if (typeof scope.querySelectorAll !== 'function') { return; }
    var els = scope.querySelectorAll('[data-cds-anim]');
    if (!els.length) { return; }
    var reduced = prefersReducedMotion();
    var hasIO = 'IntersectionObserver' in window;
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.dataset.cdsAnimDone || el.dataset.cdsAnimWatching) { continue; }
      if (reduced || !hasIO) {
        revealNow(el);
      } else {
        el.dataset.cdsAnimWatching = '1';
        observe(el);
      }
    }
  }

  function retrigger(root) {
    var els = root.querySelectorAll('[data-cds-anim]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var cls = el.getAttribute('data-cds-anim');
      if (!cls) { continue; }
      el.classList.remove(cls);
      /* force reflow */
      void el.offsetHeight;
      delete el.dataset.cdsAnimDone;
      revealNow(el);
    }
  }

  window.CDSAnim = { scan: scan };

  scan(document);

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var target = e && e.target;
      if (!target || typeof target.querySelectorAll !== 'function') { return; }
      if (target.querySelector('[data-cds-anim]')) {
        retrigger(target);
      }
    });
  }
})();
